import { render, staticRenderFns } from "./NotificationBecomeProjectMember.vue?vue&type=template&id=3506ff66&scoped=true&lang=pug&"
import script from "./NotificationBecomeProjectMember.vue?vue&type=script&lang=js&"
export * from "./NotificationBecomeProjectMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3506ff66",
  null
  
)

export default component.exports